"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAT_TILE_TONE_CLASSES = void 0;
var STAT_TILE_TONE_CLASSES = {
    primary: { icon: "bg-primary-navy/10 text-primary-navy", progress: "bg-primary-navy", helper: "text-primary-green", spark: "#021c37" },
    success: { icon: "bg-green-100 text-green-700", progress: "bg-green-600", helper: "text-primary-green", spark: "#127807" },
    warning: { icon: "bg-amber-100 text-amber-700", progress: "bg-amber-500", helper: "text-medium-gray", spark: "#eda100" },
    critical: { icon: "bg-red-100 text-red-700", progress: "bg-red-500", helper: "text-medium-gray", spark: "#d03b3b" },
    neutral: { icon: "bg-gray-100 text-medium-gray", progress: "bg-gray-400", helper: "text-medium-gray", spark: "#898781" },
    info: { icon: "bg-blue-100 text-blue-700", progress: "bg-blue-500", helper: "text-medium-gray", spark: "#2a78d6" },
    accent: { icon: "bg-purple-100 text-purple-700", progress: "bg-purple-500", helper: "text-primary-green", spark: "#7c3aed" },
};
exports.STAT_TILE_TONE_CLASSES = STAT_TILE_TONE_CLASSES;
